module.exports = __webpack_public_path__ + "img/takeaway-banner-h5-clean.99e0378d.png";